/**
 * Canonical core version — exported so hosts stop re-resolving
 * require.resolve('@zelari/core/package.json') (2.6.1 plan §7).
 * Kept in sync with package.json by scripts/verify-versions.mjs.
 */
export const CORE_VERSION = '2.6.2';
